import { Component, ElementRef, Inject, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Language, LanguageService } from '../../services/language.service';
// import { TranslationService } from '../../services/translation.service';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { Subscription } from 'rxjs';
import { SharedService } from '../../shared/services/shared.service';
import { Translations, TranslationService } from '../../shared/services/translation.service';

import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CustomerFormService } from 'app/customer-form/_services/customer-form.service';
import { LoadingScreenService } from 'app/shared/services/loading-screen/loading-screen.service';
import { ContractSignDialogComponent, ContractSignDialogResult } from './contract-sign-dialog.component';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    RouterModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
],
})
export class TermsConditionsComponent implements OnInit, OnDestroy {
  @ViewChild('termsContainer') termsContainer!: ElementRef;
  showScrollTop = false;

  translations!: Translations;
  agreed = false;
  isAgreed: boolean = false;
  isChecked = false;
  ischanged = false;
  langSubscription: Subscription = new Subscription();
  isLoading = true;
  currentStep = 1;
  currentLanguage: Language = 'en';
  language = "";
  public agreedByVisible = true;
  agreedBy: FormControl<any> = new FormControl('');
  private translationSubscription!: Subscription;

  contractId: string | null = null;
  contractContent: string = '';
  safeContractContent: SafeHtml = '';
  signedFullName: string = '';
  signedSignature: string = '';
  contractLoadError: string = '';

  constructor(
    public languageService: LanguageService,
    private translationService: TranslationService,
    private ngZone: NgZone,
    private sharedService: SharedService,
    public dialogRef: MatDialogRef<TermsConditionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {checked: boolean},
    private loadingScreenService: LoadingScreenService,
    private customerFormService: CustomerFormService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog
  ) { 
    this.translationSubscription = this.translationService.translations$.subscribe(
      (translations: Translations) => {
        this.ngZone.run(() => {
          this.translations = translations;
        });
      }
    );
  }

  ngOnInit() {
    this.language = localStorage.getItem("selectedLanguage") || "en";
    console.log("language", this.language);
    this.isLoading = true;
    this.contractLoadError = '';
    this.loadContract();

    // Get the current step from the shared service
    this.sharedService.getCurrentStep().subscribe((step) => {
      this.currentStep = step;
    });

    // Get current language from service
    this.currentLanguage = this.languageService.getCurrentLang();

    // Subscribe to translations
    this.translationSubscription =
      this.translationService.translations$.subscribe(
        (translations: Translations) => {
          this.ngZone.run(() => {
            this.translations = translations;
          });
        }
      );

    // Ensure we're using the correct language
    this.languageService.setLanguage(this.currentLanguage);

    // Get agreement state from shared service
    this.sharedService.getTermsAgreed().subscribe((agreed: boolean) => {
      this.agreed = agreed;
    });  
  }

  ngAfterViewInit() {
  const container = this.termsContainer?.nativeElement;
  if (container) {
    container.scrollTop = 0;
    container.addEventListener('scroll', () => {
      this.showScrollTop = container.scrollTop > 300; // adjust threshold as needed
      });
    } 
  }
 
  scrollToTop() {
    if (this.termsContainer?.nativeElement) {
      this.termsContainer.nativeElement.scrollTop = 0;
    }
  }

  ngOnDestroy() {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }

  getTranslation(path: string, fallback: string): string {
    if (!this.translations) return fallback;

    const parts = path.split('.');
    let value: any = this.translations;

    for (const part of parts) {
      if (!value || typeof value !== 'object') {
        return fallback;
      }
      value = value[part];
    }

    return value || fallback;
  }

  onAgreementChange(event: MatCheckboxChange): void {
    this.ischanged = true;
    this.agreed = event.checked;
    this.sharedService.setTermsAgreed(event.checked);
    this.isAgreed = true;
    // this.isChecked = event.checked;

    // Save to form data
    const formData = this.sharedService.getFormData() || {};
    formData.agreed = event.checked;
    if (event.checked && !formData.agreedBy) {
      formData.agreedBy = '';
    }
    this.sharedService.saveFormData(formData);
  }

  continueToForm(): void {
    // Close with the signed contract details so the customer form can submit.
    this.dialogRef.close({
      agreed: true,
      name: this.signedFullName,
      submitNow: true,
      commonContractOnBoardingDTO: {
        id: this.contractId,
        content: this.contractContent,
        fullName: this.signedFullName,
        signature: this.signedSignature,
      },
    });
    if (this.agreed) {
      // Save form data
      const formData = this.sharedService.getFormData() || {};
      formData.agreed = true;
      if (!formData.agreedBy) {
        formData.agreedBy = '';
      }
      this.sharedService.saveFormData(formData);

      // Set terms agreed state
      this.sharedService.setTermsAgreed(true);

      // Navigate back to service agreement section
      this.sharedService.setCurrentStep(3);
    }
  }

  goBack(): void {
    // Reset the checkbox to unchecked state
    this.dialogRef.close(null);
    this.agreed = false;
    this.isAgreed = false;

    // Save the current state with the checkbox unchecked
    const formData = this.sharedService.getFormData() || {};
    formData.agreed = false;
    this.sharedService.saveFormData(formData);

    // Set step and navigate back to the service agreement section
    this.sharedService.setCurrentStep(3);
    // this.router.navigate(['/onboarding']);
  }

  onLanguageChange(lang: Language): void {
    this.currentLanguage = lang;
    this.languageService.setLanguage(lang);
  }

  loadContract() {
    this.loadingScreenService.show();
    this.isLoading = true;
    this.contractLoadError = '';
    // this.loadingCount++;
    this.customerFormService.getContract().subscribe({
      next: (contract) => {
        console.log('Contract loaded:', contract);
        this.contractId = contract?.id ?? null;
        this.contractContent = contract?.content ?? '';
        // Content is HTML-like (contains <br> etc). We display it as HTML.
        this.safeContractContent = this.sanitizer.bypassSecurityTrustHtml(this.contractContent);
        this.signedFullName = contract?.fullName ?? '';
        this.signedSignature = contract?.signature ?? '';
        if (this.signedFullName) this.agreedBy.setValue(this.signedFullName);
        this.loadingScreenService.hide();
        this.isLoading = false;
        setTimeout(() => this.scrollToTop(), 0);
        // if(this.loadingCount <= 1) this.loadingScreenService.hide();
        // this.loadingCount--;
      },
      error: (error) => {
        console.error('Error loading contract:', error);
        this.loadingScreenService.hide();
        this.contractLoadError = 'Unable to load contract content.';
        this.contractContent = '';
        this.safeContractContent = this.sanitizer.bypassSecurityTrustHtml(
          '<p>Unable to load contract content.</p>'
        );
        this.isLoading = false;
      }
    });
  }

  openSignDialog(): void {
    if (!this.data?.checked) return;

    const ref = this.dialog.open(ContractSignDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      autoFocus: false,
      data: { initialFullName: this.signedFullName || '' },
    });

    ref.afterClosed().subscribe((result: ContractSignDialogResult | null) => {
      if (!result) return;
      this.signedFullName = result.fullName;
      this.signedSignature = result.signatureDataUrl;
      this.agreedBy.setValue(result.fullName);

      // Requirement: no separate submit button in this dialog.
      // Submitting the signature closes this dialog and triggers customer form submission.
      this.continueToForm();
    });
  }
}
